// @ts-nocheck
import { Box, Button, Card, Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { DateUtils } from '../../../../common/utils';
import { Action, HouseholdDevice } from '../../types';

function HouseholdDeviceCard({ device, onAction }: { device: HouseholdDevice; onAction: (action: Action) => void }) {
  const [t] = useTranslation();

  const handleActionClick = (action: Action) => onAction(action);

  return (
    <Card variant="outlined" style={{ padding: 16, marginBottom: 16 }}>
      <Box display="flex" alignItems="center" mb={1} fontSize="h6.fontSize">
        <Icon style={{ marginRight: 8 }} color="primary">devices</Icon>
        <strong>{device.name}</strong>
      </Box>
      <Box mb={1}>
        <strong>{t('household.householdAccess')}:</strong> {device.access}
      </Box>
      {device.inHouseholdAt && (
        <Box mb={1}>
          <strong>{t('household.householdJoinedAt')}:</strong> {DateUtils.format(new Date(device.inHouseholdAt), 'ddd, DD MMM YYYY HH:mm:ss Z')}
        </Box>
      )}
      {device.actions && device.actions.length > 0 && 
      (<>
        <Box mb={1}>
        <strong>{t('household.householdActions')}:</strong>
        </Box>
        <Box display="flex" flexDirection="column" gap={1}>
            {device.actions?.map(action => (
              <Box key={action.name} mb={0.5}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => handleActionClick(action)}>
                  {action.name}
                </Button>
              </Box>
            ))}
          </Box>
        </>)}
    </Card>
  );
}

export default HouseholdDeviceCard;
